import ClassBase from '../classBase';
import {pxToRem} from '../common/convert';
class text extends ClassBase {
  constructor(opts) {
    super(opts);
    this.settings=Object.assign({
      width:"",
      height:"",
      text:"",
      align:"left", //left,center,right
      valign:"",  //top,middle,bottom
      style:""
    },this.settings);
  }

  init() {
    require('./index.css');
    let tpl = require('./index.tpl.html');
    this.$html=$(tpl);
    this.settings.text=this.settings.text.replace(/\n/g,"</br>");
    this.$html.find(".layout").html(this.settings.text);
    this.$html.addClass("text_"+this.settings.align);
    if(this.settings.style){
      this.$html.attr("style",this.settings.style);
    }
    if(this.settings.valign){
      this.$html.addClass("text_"+this.settings.valign);
    }
    if(this.settings.width){
      this.$html.width(pxToRem(this.settings.width));
    }
    if(this.settings.height){
      this.$html.height(pxToRem(this.settings.height));
    }
  }
}
export default function(opts) {
  let instance = new text(opts);
  instance.init();
  return instance;
}



// WEBPACK FOOTER //
// ./src/component/text/index.js